<template>
  <div>
    <!-- 请假表单 -->
    <van-form
      validate-first
      :show-error="false"
      @submit="
        () => {
          if (isOpenLeaveBtn) {
            // 批量请假
            batchOnSubmit();
          } else {
            // 单次请假
            onSubmit();
          }
        }
      "
    >
      <div class="form-wrap">
        <!-- 请假人 -->
        <van-field
          label="请假人"
          size="large"
          placeholder="点击选择请假学生"
          :rules="rules.leaveName"
          v-model="form.leaveName"
          @click="$refs.interviewee.showiIntervieweePopup = true"
          readonly
        >
        </van-field>
        <!-- 请假事项 -->
        <van-field
          v-model="form.leaveType"
          label="请假事项"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          size="large"
          @click="showPicker = true"
          :rules="rules.leaveType"
        />
        <!-- 请假原因  -->
        <van-field
          type="textarea"
          placeholder="请输入原因"
          label="请假原因"
          autosize
          v-model="form.remark"
          size="large"
        />
        <!-- 批量多天请假  -->
        <div class="switch_leave">
          <span>批量多天请假</span>
          <van-switch
            size="24px"
            @change="switchType"
            v-model="isOpenLeaveBtn"
          />
        </div>

        <!-- 开始日期 -->
        <van-field
          v-if="isOpenLeaveBtn"
          v-model="form.leaveBeginDate"
          label="开始日期"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          @click="clickTime('startDate')"
          :rules="rules.leaveBeginDate"
          size="large"
        />
        <!-- 结束日期  -->
        <van-field
          v-if="isOpenLeaveBtn"
          v-model="form.leaveEndDate"
          label="结束日期"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          :rules="rules.leaveEndDate"
          @click="form.leaveBeginDate && clickTime('endDate')"
          size="large"
        />

        <!-- 开始时间  -->
        <van-field
          v-model="form.leaveBeginTime"
          label="开始时间"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          @click="clickTime(`${!isOpenLeaveBtn ? 'starttime' : 'starttime_batch'}`)"
          :rules="rules.leaveBeginTime"
          size="large"
        />
        <!-- 结束时间  -->
        <van-field
          v-model="form.leaveEndTime"
          label="结束时间"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          :rules="rules.leaveEndTime"
          @click="form.leaveBeginTime && clickTime(`${!isOpenLeaveBtn ? 'endtime' : 'endtime_batch'}`)"
          size="large"
        />

        <van-field
          v-model="form.auditName"
          label="审批人"
          placeholder="请选择审批人"
          size="large"
          clickable
          readonly
          :rules="rules.auditName"
        />
        <van-field
          v-model="form.makeInfo"
          label="抄送范围"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          size="large"
          @click="$refs.ccrequest.showCcRequest = true"
        />

        <!-- <van-field
          v-model="duration"
          label="时长"
          placeholder="时长"
          size="large"
          readonly
          v-if="form.leaveBeginTime && form.leaveEndTime"
        /> -->
      </div>

      <div style="margin: 16px">
        <van-button
          round
          block
          :loading="btn_loading"
          :disabled="btn_loading"
          type="info"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>

    <!-- 事项选择  -->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        title="事项"
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <!-- 开始日期 -->
    <SelectTime
      ref="startDate"
      type="date"
      :typeTime="'选择开始日期'"
      @time="handleDateStartConfirm"
      :minDate="new Date()"
      :isFilter="false"
    />
    <!-- 结束日期 -->
    <SelectTime
      ref="endDate"
      type="date"
      :typeTime="'选择结束日期'"
      @time="handleDateEndConfirm"
      :minDate="new Date()"
      :isFilter="false"
    />

    <!-- 开始时间 -->
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :currentDate="startMinTime"
      :minDate="new Date()"
      :isFilter="false"
    />

    <!-- 结束时间  -->
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :minDate="!isOpenLeaveBtn ? endMinDate : ''"
      :isFilter="false"
      :currentDate="!isOpenLeaveBtn ?endCurTime : ''"
    />


    <!-- 学生批量请假开始时间和结束时间 -->
    <SelectDate ref="starttime_batch"  @time="handleTimeStartConfirm_batch" :typeTime="'选择开始时间'" :currentDate="form.leaveBeginTime"/>
    <SelectDate ref="endtime_batch" @time="handleTimeEndConfirm_batch" :typeTime="'选择结束时间'"  :currentDate="form.leaveEndTime"/>


    <Interviewee
      ref="interviewee"
      @selectItem="handleSelIntervieweeItem"
      pageType="teacher"
    />

    <!-- 抄送人组件 -->
    <CcRequest personType="teacher" leaveType="0" ref="ccrequest" @selectItem="handleCcSelectItem"/>
  </div>
</template>

<script>
import moment from "moment";
import { compare, getDateYMD, timeFormart } from "@/utils";
import CcRequest from '@/components/subScribePopup/ccrequest'
import Interviewee from "@/components/subScribePopup/intervieweeClass";
import SelectTime from "@/components/subScribePopup/selectTime";
import SelectDate from "@/components/subScribePopup/selectDate";

export default {
  data() {
    return {
      form: {},
      showPicker: false,
      columns: [
        "事假",
        "病假",
        "工伤假",
        "婚假",
        "丧假",
        "产假",
        "探亲假",
        "公假",
        "年休假",
      ],
      endMinDate: "",
      startMinTime: new Date(moment().endOf("hours").add(1, "s")),
      btn_loading: false,
      childList: [],
      // 批量多天请假开启关闭
      isOpenLeaveBtn: false,
      // 抄送人列表
      makeUserList:[],
      // 抄送部门列表
      makeDeptList: [],
      rules: {
        leaveType: [
          {
            required: true,
            message: "请选择事项",
            trigger: "onChange",
          },
        ],
        leaveBeginTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "onChange",
          },
        ],
        leaveEndTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "onChange",
          },
        ],
        leaveBeginDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "onChange",
          },
        ],
        leaveEndDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "onChange",
          },
        ],
        auditName: [
          {
            required: true,
            message: "请选择审批人",
            trigger: "onChange",
          },
        ],
        remark: [
          {
            required: true,
            message: "请填写备注",
            validator: (value, rule) => {
              rule.message = "输入字符大于50位";
              return value.length <= 50;
            },
          },
        ],
        leaveName: [
          {
            required: true,
            message: "请选择请假人",
            trigger: "onChange",
          },
        ],
      },
    };
  },

  mounted() {
    // if (this.personType == 12) {
    //   this.getAllChild()
    // }
    console.log(this.$router.query);
    // const uname = JSON.parse(localStorage.getItem("userInfo")).name;
    // this.$set(this.form, "leaveName", uname);
    // if (this.personType == 13) {
    //   const uname = JSON.parse(localStorage.getItem('userInfo')).name
    //   this.$set(this.form, 'leaveName', uname)
    // }
    this.getLastLeaveDetail();
    // console.log()
  },
  computed: {
    personType() {
      return JSON.parse(localStorage.getItem("userInfo")).personType;
    },
    // startMinTime() {
    //   // return new Date(moment().add(1, 'h'))
    //   return new Date(
    //     moment()
    //       .endOf('hours')
    //       .add(1, 's')
    //   )
    // },
    endCurTime() {
      return new Date(moment(this.endMinDate).add(1, "h"));
    },
    endMaxTime() {
      return new Date(moment(this.endMinDate).add(this.maxDuration, "hours"));
    },
    duration() {
      var m1 = moment(this.form.leaveBeginTime),
        m2 = moment(this.form.leaveEndTime);
      var du = moment.duration(m2 - m1, "ms"),
        month = du.get("month"),
        day = du.get("days"),
        hours = du.get("hours"),
        mins = du.get("minutes"),
        ss = du.get("seconds");
      const duration =
        month + "月" + day + "天" + hours + "时" + mins + "分" + ss + "秒";
      return duration;
      // this.$set(this.form, 'visitorIdCrde', duration)
    },
  },
  methods: {
    onConfirm(value, index) {
      this.$set(this.form, "leaveType", value);
      this.showPicker = false;
    },

    clickTime(type) {
      this.$refs[type].showTimePopup = true;
    },

    // 选择开始日期
    handleDateStartConfirm(value) {
      console.log("value", value);
      this.$set(this.form, "leaveBeginDate", value);
      // this.endMinDate = new Date(value.replace(/-/g, "/"));
      this.$refs.startDate.showTimePopup = false;
      this.$refs.endDate.showTimePopup = true;
    },

    // 选择结束日期
    handleDateEndConfirm(value) {
      console.log("value", value);
      this.$set(this.form, "leaveEndDate", value);
      this.$refs.endtime.showTimePopup = false;
    },

    // 选择开始时间
    handleTimeStartConfirm(value) {
      console.log("拿到传回的值value", value);
      // return
      this.$set(this.form, "leaveBeginTime", value);
      console.log("this.form", this.form);
      if (!this.isOpenLeaveBtn) {
        this.endMinDate = new Date(value.replace(/-/g, "/"));
      }
      
      this.$refs.starttime.showTimePopup = false;
      this.$refs.endtime.showTimePopup = true;
    },

    // 选择结束时间
    handleTimeEndConfirm(value) {
      console.log("结束时间", value);
      this.$set(this.form, "leaveEndTime", value);
      this.$refs.endtime.showTimePopup = false;
    },

    // 批量请假开始时间
    // 选择开始时间
    handleTimeStartConfirm_batch(value) {
      console.log("拿到传回的值value", value);
      // return
      this.$set(this.form, "leaveBeginTime", value);
      console.log("this.form", this.form);
     
      
      this.$refs.starttime_batch.showTimePopup = false;
      this.$refs.endtime_batch.showTimePopup = true;
    },

    // 选择结束时间
    handleTimeEndConfirm_batch(value) {
      console.log("结束时间", value);
      this.$set(this.form, "leaveEndTime", value);
      this.$refs.endtime_batch.showTimePopup = false;
    },

    // 批量请假结束时间

    switchType(e) {
      if (e) {
        this.$set(this.form, "leaveBeginTime",moment().endOf("hours").add(1, "s").format("HH:mm"));
        this.$set(this.form, "leaveEndTime",moment(this.endCurTime).format("HH:mm"));
      } else {
        this.$set(
          this.form,
          "leaveBeginTime",
          moment().endOf("hours").add(1, "s").format("YYYY-MM-DD HH:mm")
        );
        this.$set(
          this.form,
          "leaveEndTime",moment(this.endCurTime).format("YYYY-MM-DD") + ' ' +  this.form.leaveEndTime
        );
      }
    },

    // 设置请假人
    handleSelIntervieweeItem(item) {
      this.$set(this.form, "leaveId", item.id);
      this.$set(this.form, "leaveName", item.name);
      this.$refs.interviewee.showiIntervieweePopup = false;
    },


    // 抄送人弹窗选择数据 
    handleCcSelectItem (item) {
      let {makeDeptList,makeUserList,state} = item
      let str = ''
      if (makeDeptList.length > 0) {
        if (makeDeptList.length == 1) {
          str = str + makeDeptList[0].deptName + `${makeUserList.length > 0 ? '，' : ''}`
        } else {
          str = str + makeDeptList.filter(s => s.children.length == 0).length + `${makeUserList.length > 0 ? '个部门，':'个部门'}`
        }
      } 
      if (makeUserList.length > 0) {
        if (makeUserList.length == 1) {
          str = str + makeUserList[0].name
        } else {
          str = str + makeUserList.length + '位老师'
        }
      } 
      this.$set(this.form, "makeInfo", str);

      this.makeUserList = makeUserList.map(x => {
        return {
          id: x.id,
          name: x.name,
          remark: x.deptName,
          avatar: x.avatar
        }
      })
      this.makeDeptList = makeDeptList.map(s => {
        return {
          id:s.id,
          name: s.deptName,
          parentId: s.parentId,
          remark: s.classNumber ? s.classNumber + '' : (s.remark || '0')
        }
      })
      if (state == 1) {
        this.$refs.ccrequest.showCcRequest = false;
      }
      
      
    },
    
    // 提交单次请假信息信息
    onSubmit(v) {
      this.btn_loading = true;
      const { leaveBeginTime, leaveEndTime, radio, ...rest } = this.form;

      // console.log("请求参数", {
      //   ...rest,
      //   leaveBeginTime,
      //   leaveEndTime,
      //   userId: this.$store.state.userId,
      //   schoolId: this.$store.state.schoolId,
      // });
      // return;

      this.$https
        .teacherAuthLeave({
          ...rest,

          leaveBeginTime: moment(leaveBeginTime).format("YYYY-MM-DD HH:mm:ss"),
          leaveEndTime: moment(leaveEndTime).format("YYYY-MM-DD HH:mm:ss"),
          userId: this.$store.state.userId,
          makeUserList:this.makeUserList,
          makeDeptList: this.makeDeptList,
          schoolId: this.$store.state.schoolId,
        })
        .then((res) => {
          if (res.code !== 200) {
            this.$toast(res.msg);
            this.btn_loading = false;
            return;
          }

          this.$toast({
            type: "success",
            overlay: true,
            message: "成功",
            duration: 1500,
            onClose: () => {
              // 跳转到请假记录
              this.$router.push("/leaveListStudent");
            },
          });
          this.btn_loading = false;
        })
        .catch(() => {
          this.btn_loading = false;
        });
    },
    batchOnSubmit(v) {
      console.log("批量请假", this.form);
      // return
      let _this = this;
      // 创建promiseAll
      let promiseAll = [];
      // 开始日期
      let startDay = this.form.leaveBeginDate;
      // 当前时间
      let nowDay = this.form.leaveBeginDate;
      // 结束日期
      let endDay = this.form.leaveEndDate;
      // 开始时间
      let startTime = moment(this.form.leaveBeginTime, "HH:mm").format(
        "HH:mm:ss"
      );
      // 结束时间
      let endTime = moment(this.form.leaveEndTime, "HH:mm").format("HH:mm:ss");

      let time = moment(new Date()).format("HH:mm");
      // console.log('startTime,endTime',endTime,startTime)
      // 结束时间和开始时间大小
      if (
        Number(startTime.split(":")[0]) == Number(endTime.split(":")[0]) &&
        Number(startTime.split(":")[1]) == Number(endTime.split(":")[1])
      ) {
        this.$toast("开始时间不能与结束时间相同");
        return;
      }
      if (
        Number(endTime.split(":")[0]) < Number(startTime.split(":")[0]) ||
        (Number(endTime.split(":")[0]) == Number(startTime.split(":")[0]) &&
          Number(endTime.split(":")[1]) < Number(startTime.split(":")[1]))
      ) {
        this.$toast("结束时间不能在开始时间之前");
        return;
      }

      while (moment(nowDay).isSameOrBefore(endDay)) {
        // 添加请
        let data = {
          auditId: this.form.auditId,
          auditName: this.form.auditName,
          auditeDeptName: this.form.auditeDeptName,
          leaveBeginTime: `${nowDay} ${startTime}`,
          leaveEndTime: `${nowDay} ${endTime}`,
          leaveId: this.form.leaveId,
          leaveType: this.form.leaveType,
          leaveName: this.form.leaveName,
          makeUserList:this.makeUserList,
          makeDeptList: this.makeDeptList,
          remark: this.form.remark,
          userId: this.$store.state.userId,
          schoolId: this.$store.state.schoolId,
        };

       
        promiseAll.push(
          new Promise((resolve, reject) => {
            _this.$https
              .teacherAuthLeave(data)
              .then((res) => {
                resolve(res);
              })
              .catch((e) => {
                reject(e);
              });
          })
        );
        nowDay = moment(nowDay).add(1, "days").format("YYYY-MM-DD");
      }

      this.btn_loading = true;
      console.log("promiseAll", promiseAll);

      Promise.all(promiseAll).then((res) => {
        // setBtnLoading(false);
        if (res.some((x) => x.code != 200)) {
          _this.$toast('批量请假添加失败');
          _this.btn_loading = false;
        } else {
          _this.$toast({
            type: "success",
            overlay: true,
            message: "成功",
            duration: 1500,
            onClose: () => {
              // 跳转到请假记录
              this.$router.push("/leaveListStudent");
            },
          });
          _this.btn_loading = false;
        }

        console.log("获取批量请假的结果", res);
      });
    },
    // async getAllChild() {
    //   const { code, data } = await this.$https.getAllChild({
    //     userId: this.$store.state.userId,
    //     schoolId: this.$store.state.schoolId,
    //   })
    //   if (code !== 200) {
    //     return
    //   }
    //   this.childList = [...data]
    //   this.$set(this.form, 'radio', data[0])
    // },

    async getLastLeaveDetail() {
      // const { code, data } = await this.$https.getLastLeaveDetail({
      //   userId: this.$store.state.userId,
      //   schoolId: this.$store.state.schoolId,
      // });
      // if (code !== 200) {
      //   return;
      // }
      // if (data.name && data.deptName) {
      //   this.$set(this.form, "auditName", `${data.name}-${data.deptName}`);
      // }
      // this.$set(this.form, "auditeDeptName", data.deptName);
      // this.$set(this.form, "auditId", data.id);
      // this.$set(
      //   this.form,
      //   "leaveBeginTime",
      //   moment().endOf("hours").add(1, "s").format("YYYY-MM-DD HH:mm")
      // );

      // 苹果兼容
      // this.startMinTime = new Date(this.form.leaveBeginTime.replace(/-/g, "/"));
      // this.endMinDate = new Date(this.form.leaveBeginTime.replace(/-/g, "/"));

      // 设置默认的审批人
      let user =
        localStorage.getItem("userInfo") &&
        JSON.parse(localStorage.getItem("userInfo"));
      if (user.name && user.deptName) {
        this.$set(this.form, "auditName", `${user.name}-${user.deptName}`);
      }
      this.$set(this.form, "auditeDeptName", user.deptName);
      this.$set(this.form, "auditId", user.id);
      this.$set(
        this.form,
        "leaveBeginTime",
        moment().endOf("hours").add(1, "s").format("YYYY-MM-DD HH:mm")
      );
      // 苹果兼容
      this.startMinTime = new Date(this.form.leaveBeginTime.replace(/-/g, "/"));
      this.endMinDate = new Date(this.form.leaveBeginTime.replace(/-/g, "/"));
    },
  },
  components: {
    Interviewee,
    SelectTime,
    SelectDate,
    CcRequest
  },
};
</script>

<style lang="scss" scoped>
.form-wrap {
  margin: 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
  .switch_leave {
    background-color: #fff;
    display: flex;
    color: #646566;
    font-size: 1rem;
    padding: 0.625rem 1rem;
    justify-content: space-between;
    align-content: center;
  }
}
</style>
